import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { DialogProps } from '@material-ui/core/Dialog';
import { MDSIcon, MDSTypography } from '@marqvision/mds-v2';
import { MDSTheme } from './index';

const popupTitleUseStyles = makeStyles(() => ({
  backDrop: {
    backdropFilter: 'blur(2px)',
    backgroundColor: 'rgba(0,0,30,0.4)',
  },
  dialogTitle: {
    padding: '16px 20px',
    borderBottom: `1px solid ${MDSTheme.palette.bluegray[200]}`,
    '& svg': {
      width: '24px',
      height: '24px',
      cursor: 'pointer',
    },
  },
}));

interface IPopupTitle {
  rootProps?: React.HTMLAttributes<HTMLDivElement>;
  startIcon?: React.ReactNode;
  onClose?: (e?: React.MouseEvent) => void;
}

type IPopupTitleProps = IPopupTitle & React.HTMLAttributes<HTMLDivElement>;
/**
 * @deprecated
 * mds-v2 사용
 */
export const MDSPopupTitle = (props: React.PropsWithChildren<IPopupTitleProps>): React.ReactNode => {
  const classes = popupTitleUseStyles();
  const { children, startIcon, onClose, rootProps, ...restProps } = props;

  return (
    <DialogTitle className={classes.dialogTitle} {...rootProps}>
      <Box display="flex" alignItems="center" gridGap="8px" {...restProps}>
        {!!startIcon && <Box>{startIcon}</Box>}
        {restProps.className ? (
          children
        ) : (
          <MDSTypography variant="title" size="xl" weight="medium">
            {children}
          </MDSTypography>
        )}
        {onClose && (
          <MDSIcon.CloseDelete
            variant="outline"
            color="color/content/neutral/default/normal"
            style={{ marginLeft: 'auto', cursor: 'pointer' }}
            onClick={onClose}
          />
        )}
      </Box>
    </DialogTitle>
  );
};

const popupContentUseStyles = makeStyles({
  dialogContent: {
    padding: '16px 20px !important',
  },
});
/**
 * @deprecated
 * mds-v2 사용
 */
export const MDSPopupContent = (
  props: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
): React.ReactNode => {
  const classes = popupContentUseStyles();
  const { children, ...restProps } = props;
  return (
    <DialogContent className={classes.dialogContent} {...restProps}>
      {children}
    </DialogContent>
  );
};

const popupActionsUseStyles = makeStyles({
  dialogActions: {
    padding: '16px 20px',
    display: 'flex',
    alignItems: 'center',
  },
});
/**
 * @deprecated
 * mds-v2 사용
 */
export const MDSPopupActions = (
  props: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
): React.ReactNode => {
  const classes = popupActionsUseStyles();
  const { children, ...restProps } = props;
  return (
    <DialogActions className={classes.dialogActions} {...restProps}>
      {children}
    </DialogActions>
  );
};

interface IPopup {
  isOpen?: boolean;
  width?: string;
  shouldApplyBackdropFilter?: boolean;
}

type IProps = React.PropsWithChildren<IPopup> & Omit<DialogProps, 'open'>;
/**
 * @deprecated
 * mds-v2 사용
 */
export const MDSPopup = (props: IProps): React.ReactNode => {
  const classes = popupTitleUseStyles();
  const { width, shouldApplyBackdropFilter, isOpen = true, children, ...dialogProps } = props;

  return (
    <Dialog
      open={isOpen}
      {...dialogProps}
      disableEnforceFocus
      BackdropProps={{
        classes: {
          root: shouldApplyBackdropFilter ? classes.backDrop : '',
        },
      }}
    >
      <Box width={width}>{children}</Box>
    </Dialog>
  );
};

export default MDSPopup;
